import { ExtendedAccountColumns } from '@/backend/features/contact-management/entities/extended-account/types';
import { RmsAccountSelection } from '@/ui/features/badging/badging-customizations/badge-create/types';
import { ManageBadgesPanelProps } from '@juvare/badging/ui/features/badge-management/ManageBadgesPanel';
import { Row } from '@juvare/platform-shared/features/storage';

export const mapAccountToAccountSelection: NonNullable<ManageBadgesPanelProps['mapAccountToAccountSelection']> = (
    row: Row<ExtendedAccountColumns>,
): RmsAccountSelection => {
    const account = row.columns;
    return {
        id: row.id,
        account,
        options: {},
    };
};
